import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    email: 'Email',
    name: 'Name',
    next: 'Next',
    title: 'Who do you want to send it to?',
    warning:
      'For example, you can choose to send the export to yourself or to one of your accounting associates!',
  },
  fr: {
    email: 'E-mail',
    name: 'Nom',
    next: 'Suivant',
    title: 'À qui souhaitez-vous l’envoyer ?',
    warning:
      'Vous pouvez choisir de vous envoyer l’export à vous-même ou à votre service comptable',
  },
});

export default locales;
